module.exports = __webpack_public_path__ + "static/media/app_logo.e3c41167.jpg";